const HAIRCUTS_STUDIO_SESSION_KEY = 'hairchitech_haircuts_studio_session_v1';
const MAKEUP_STUDIO_SESSION_KEY = 'hairchitech_makeup_studio_session_v1';
const NAILS_STUDIO_SESSION_KEY = 'hairchitech_nails_studio_session_v1';

export const clearHaircutsStudioSession = () => {
  try {
    localStorage.removeItem(HAIRCUTS_STUDIO_SESSION_KEY);
    localStorage.removeItem('hs_gender');
    localStorage.removeItem('hs_color_mode');
  } catch (_) {
    // Storage can be unavailable in private browsing or hardened browsers.
  }
};

export const clearMakeupStudioSession = () => {
  try {
    localStorage.removeItem(MAKEUP_STUDIO_SESSION_KEY);
  } catch (_) {
    // Storage can be unavailable in private browsing or hardened browsers.
  }
};

export const clearNailsStudioSession = () => {
  try {
    localStorage.removeItem(NAILS_STUDIO_SESSION_KEY);
  } catch (_) {
    // Storage can be unavailable in private browsing or hardened browsers.
  }
};

export const clearAiStudioSessions = () => {
  clearHaircutsStudioSession();
  clearMakeupStudioSession();
  clearNailsStudioSession();
};

export const loadHaircutsStudioSession = () => {
  try {
    const rawSession = localStorage.getItem(HAIRCUTS_STUDIO_SESSION_KEY);
    if (!rawSession) return null;
    return JSON.parse(rawSession);
  } catch (_) {
    clearHaircutsStudioSession();
    return null;
  }
};

export const saveHaircutsStudioSession = (session) => {
  try {
    localStorage.setItem(HAIRCUTS_STUDIO_SESSION_KEY, JSON.stringify({
      ...session,
      savedAt: Date.now(),
    }));
    return true;
  } catch (_) {
    return false;
  }
};

export const loadMakeupStudioSession = () => {
  try {
    const rawSession = localStorage.getItem(MAKEUP_STUDIO_SESSION_KEY);
    if (!rawSession) return null;
    return JSON.parse(rawSession);
  } catch (_) {
    clearMakeupStudioSession();
    return null;
  }
};

export const saveMakeupStudioSession = (session) => {
  try {
    localStorage.setItem(MAKEUP_STUDIO_SESSION_KEY, JSON.stringify({
      ...session,
      savedAt: Date.now(),
    }));
    return true;
  } catch (_) {
    return false;
  }
};

export const loadNailsStudioSession = () => {
  try {
    const rawSession = localStorage.getItem(NAILS_STUDIO_SESSION_KEY);
    if (!rawSession) return null;
    return JSON.parse(rawSession);
  } catch (_) {
    clearNailsStudioSession();
    return null;
  }
};

export const saveNailsStudioSession = (session) => {
  try {
    localStorage.setItem(NAILS_STUDIO_SESSION_KEY, JSON.stringify({
      ...session,
      savedAt: Date.now(),
    }));
    return true;
  } catch (_) {
    return false;
  }
};

export const dataUrlToFile = async (dataUrl, filename = 'haircuts-studio-photo.jpg') => {
  if (!dataUrl || typeof dataUrl !== 'string') return null;

  try {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    const mimeType = blob.type || 'image/jpeg';
    return new File([blob], filename, { type: mimeType });
  } catch (_) {
    return null;
  }
};
